var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonRemoveLineRedBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#ED484B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.98344C17.725 7.70844 14.9333 7.56677 12.15 7.56677C10.5 7.56677 8.85 7.65011 7.2 7.81677L5.5 7.98344",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.083 7.14156L10.2663 6.0499C10.3997 5.25823 10.4997 4.66656 11.908 4.66656H14.0913C15.4997 4.66656 15.608 5.29157 15.733 6.05823L15.9163 7.14156",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7082 10.6168L18.1665 19.0084C18.0748 20.3168 17.9998 21.3334 15.6748 21.3334H10.3248C7.99984 21.3334 7.92484 20.3168 7.83317 19.0084L7.2915 10.6168",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6084 16.75H14.3834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.917 13.4166H15.0837",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRemoveLineRedBg);
export default __webpack_public_path__ + "static/media/button-remove-line-red-bg.d5440c15634df0cb9ebcc73f118fb821.svg";
export { ForwardRef as ReactComponent };